$(function() {
  var duration = 500;
  var duration2 = 500;

  var current_scrollY_start = $(window).scrollTop();

  // タブレットレイアウトをPCと統一
  var metaDiscre = document.head.children;
  var metaLength = metaDiscre.length;
  console.log('window:' + window.outerWidth);
  if(window.outerWidth > 700 && window.outerWidth < 1250){
    for(var i = 0;i < metaLength;i++){
       var proper = metaDiscre[i].getAttribute('name');
        if(proper === 'viewport'){
          console.log('tablet')
          var dis = metaDiscre[i];
          dis.setAttribute('content','width=1440');
        }
    }
  }

  function preSetScript() {

    // スクロール + ウィンドウサイズ系の対策処理
    function scrollAnimationSet(target) {
      const scButtonWrap = $('#scrollTopWrap');
      const fixedButton = $('#fixedButton');
      const header = $('#fixedHeader');
      const position = document.documentElement;
      let pageHeight;
      let wHeight = window.innerHeight;
      let preSetWidth = window.innerWidth;
      let scrollCount = 0;

      function setHeightProperty() {
        wHeight = window.innerHeight;
        pageHeight = $('body').innerHeight();
        position.style.setProperty('--wHeight', window.innerHeight);
        position.style.setProperty('--wHeightPx', window.innerHeight + 'px');
        position.style.setProperty('--scroll', window.scrollY);
        if (window.scrollY > 100) {
          header.addClass('rolled');
        } else {
          header.removeClass('rolled');
        }
        if (document.getElementById('bgWhite')) {
          var imgPos = $('#bgWhite').offset().top;
          var windowHeight = $(window).height();
          if (document.getElementById('whiteHeader')) {
            if (window.scrollY > imgPos - windowHeight + windowHeight / 10) {
              header.removeClass('white');
            } else {
              header.addClass('white');
            }
          }
          if (window.scrollY > imgPos - windowHeight + windowHeight / 5) {
            $('article').removeClass('black');
            $('#bgWhite').removeClass('effect');
          } else {
            $('article').addClass('black');
            $('#bgWhite').addClass('effect');
          }
        }
        /*$(".func-scroll-animation").each(function() {
          var imgPos = $(this).offset().top;
          var scroll = $(window).scrollTop();
          var windowHeight = $(window).height();
          if (scroll > imgPos - windowHeight + windowHeight / 4) {
            $(this).removeClass('effect');
          }
        });*/
        requestAnimationFrame(setProperties);
      }

      function setProperties() {
        setHeightProperty();
      }

      function init() {
        var timer = false;
        setProperties();
        position.style.setProperty('--wHeightFixedPx', window.innerHeight + 'px');
      }

      init();

    }

    scrollAnimationSet($('article'));

    //アンカーリンクで追従ヘッダーの分オフセットする
    window.onload = function() {
      var urlHash = location.hash;
      if(urlHash != undefined && urlHash.length > 1){
        if (0 < urlHash.length) {
          location.hash = urlHash;
          var scroll = $(urlHash).offset().top;
          var w = $(window).width();

          if (w < 780) {
            var adScroll = scroll - 60;
          } else {
            var adScroll = scroll - 150;
          }

          $("html, body").animate({
            scrollTop: adScroll
          }, 0);
        }
      }
    }


    // ハンバーガーメニューの開閉
    function humMenuControll(target) {
      var header = $('header');
      var humMenuState = 0;
      var humButton = $('#humButton');
      var hummenuState = 0;

      var hummenuNav = $('#hummenuNav');
      var navItem = [];
      var navButton = [];
      var navToggle = [];
      var toggleState = [];
      var currentToggle = -1;

      var hummenuClose = $('#hummenuClose');

      function hummenuOpen() {
        if(hummenuState == 0){
          target.addClass('open');
          humButton.addClass('open');
          hummenuState = 1;
        }else{
          target.removeClass('open');
          humButton.removeClass('open');
          hummenuState = 0;
        }
      }


      function navToggleControll(e) {
        console.log('e:' + e);
        console.log('toggleState:' + toggleState[e]);
        console.log('currentToggle:' + currentToggle);
        if(currentToggle != -1 && currentToggle != e ){
          toggleState[currentToggle] = 0;
        }

        $('.active_button').removeClass('active_button');
        if ( toggleState[e] == 0) {
          navItem[e].addClass('active_button');
          var buttonHeight = navButton[e].innerHeight();
          var tagetHeight = navToggle[e].innerHeight();
          hummenuClose.addClass('display');
          navItem[e].css({
            'height': buttonHeight + tagetHeight + 'px'
          });
          toggleState[e] = 1;
          currentToggle = e;
        } else {
          navItem[e].removeClass('active_button');
          hummenuClose.removeClass('display');
          var buttonHeight = navButton[e].innerHeight();
            navItem[e].css({
              'height': buttonHeight + 'px'
            });
          toggleState[e] = 0;
          currentToggle = -1;
        }

      }


      function init() {
        humButton.on({
          'click': function() {
            console.log('click');
            hummenuOpen();
          }
        });

        hummenuClose.on({
          'click': function() {
            console.log('click');
            navToggleControll(currentToggle);
          }
        });

        $('header').on({
          'click': function() {
            console.log('click');
            navToggleControll(currentToggle);
          }
        });

        $(document).on('click', function() {
          /*console.log('click!');
          if(currentToggle != -1){
            console.log('currentToggle:' + currentToggle);
            $('.active_button').removeClass('active_button');
            toggleState[currentToggle] = 0;
            currentToggle = -1;
          }*/
        });


        $.each(hummenuNav.find('.nav_item'), function(index) {
          navItem[index] = $(this);
          navButton[index] = $(this).find('button');
          navToggle[index] = $(this).find('.toggle_box');
          toggleState[index] = 0;
          navItem[index].css({'height': navButton[index].innerHeight() + 'px'});
          navButton[index].on({
            'click': function() {
              navToggleControll(index);
            }
          });
        });

      }

      init();
    }

    humMenuControll($('#humMenu'));

    // ヘッダー キーワード検索
    function keyWordSearchControll(target){
      var headerSearchButton = $('#headerSearchButton');
      var searchCloseButton = $('#searchCloseButton');
      var searchFilterButton = $('#searchFilterButton');
      var searchState = 0;

      var filterButton = [];
      var filterButtonState = [];

      function filterSelect(e){
        if(filterButtonState[e] == 0){
          filterButton[e].addClass('active');
          filterButtonState[e] = 1;
        }else{
          filterButton[e].removeClass('active');
          filterButtonState[e] = 0;
        }
      }

      function seachWrapDisplay(){
        if(searchState == 0){
          target.addClass('open');
          searchState = 1;
        }else{
          target.removeClass('open');
          searchState = 0;
        }
      }

      function init(){

        headerSearchButton.on({
          'click': function() {
            seachWrapDisplay();
          }
        });

        searchCloseButton.on({
          'click': function() {
            seachWrapDisplay();
          }
        });


        $.each(searchFilterButton.find('button'), function(index) {
          filterButton[index] = $(this);
          filterButtonState[index] = 0;
          filterButton[index].on({
            'click': function() {
              filterSelect(index);
            }
          });
        });

      }

      init();

    }

    keyWordSearchControll($('#SearchWrapHeader'));

    function keywordSearch(target){
      var searchInput = target.find('input[name=q]');
      var searchButton = target.find('button');

      function init(){

        searchButton.on({
          'click': function() {
            var searchWord = searchInput.val();
            searchWord = searchWord.replace(/　/g," ");
            location.href = 'https://' + location.hostname + '/search?q=' + searchWord + '';
          }
        });
      }


      init();

    }

    keywordSearch($('#SearchWrapHeader'));

    //商品詳細ページ サムネイルの切り替え
    function thumbSwitcher(target){
      let thumbButton = [];
      let thumbSrc = [];
      let thumbSrcSet = [];
      let thumbBox = target.find('.img_wrapper');
      let thumbImage = thumbBox.find('img');
      let slideNum = target.find('.thumbnails').find('img').length;
      const time = 200;
      let currentSlide = 0;
      let prevArrow = $('#prevArrow');
      let nextArrow = $('#nextArrow');
      console.log('slideNum:' + slideNum);

      function switchImage(num){
        console.log('num:' + num);
        thumbBox.stop().animate({ opacity: 0 }, time, function() {
            thumbImage.attr('src', thumbSrc[num]);
            thumbImage.attr('srcset', thumbSrcSet[num]);
            $('.active_thumb').removeClass('active_thumb');
            thumbButton[num].addClass('active_thumb');
            thumbBox.stop().animate({ opacity: 1 }, time);
        });
      }

      function thumbHeightControll(){
        var thumbHeight = thumbImage.outerHeight();
        $('#thumnails').css({'max-height': thumbHeight + 'px'});
        requestAnimationFrame(thumbHeightControll);
      }

      function slideNext(){
        if (currentSlide < slideNum - 1) {
          currentSlide = currentSlide + 1;
        } else {
          currentSlide = 0;
        }
        thumbButton[currentSlide].click();
        /*switchImage(currentSlide);*/
      };

      function slidePrev(){
        if (currentSlide == 0) {
          currentSlide = slideNum - 1;
        } else {
          currentSlide = currentSlide - 1;
        }
        thumbButton[currentSlide].click();
        /*switchImage(currentSlide);*/
      };

      function tabTouch(){
        if(startTouchX - endTouchX > 50){
          slideNext();
        }else if(startTouchX - endTouchX < - 50){
          slidePrev();
        }
      };

      function windowDrag() {
        if (startDragX - endDragX > 100) {
          slideNext();
        } else if (startDragX - endDragX < -100) {
          slidePrev();
        }
      };

      function init(){
        thumbHeightControll();
        $.each(target.find('.thumbnails').find('button'), function(index) {
          thumbButton[index] = $(this);
          thumbSrc[index] = $(this).find('img').attr("src");
          thumbSrcSet[index] = $(this).find('img').attr("srcset");
          thumbButton[index].on({
            'click': function() {
              switchImage(index);
            }
          });
        });

        thumbBox.find('img').on({
          'dragstart': function(e) {
            event.preventDefault();
            startDragX = event.pageX;
          },
          'dragend': function(e) {
            endDragX = event.pageX;
            windowDrag();
          }
        });

        thumbBox.find('img').on({
          'touchstart' : function(e){
            event.preventDefault();
            startTouchX = event.changedTouches[0].pageX;
          },
          'touchmove' : function(e){
          },
          'touchend' : function(e){
            endTouchX = event.changedTouches[0].pageX;
            tabTouch();
          }
        });

        prevArrow.on({
          'click': function(){
            slidePrev();
          }
        });

        nextArrow.on({
          'click': function(){
            slideNext();
          }
        });

        $(window).on({
          'resize': function(){
            thumbHeightControll();
          }
        });
      }

      init();

    }

    if (document.getElementById('product')) {
      thumbSwitcher($('#prodImages'));
    }

    //商品詳細ページ 購入数の増減
    function cartWrapControll(){
      var minusButton = $('#minusButton');
      var plusButton = $('#plusButton');
      var quantityInput = $('#quantityInput');
      var quantityNum = 1;
      var optionSelector = $('#optionSelector');
      var optionLabel = [];
      var labelState = [];

      function controllQuantity(vector){
        quantityNum = quantityInput.val();
        if(vector == 1){
          quantityInput.attr('value', Number(quantityNum) + 1);
          quantityNum = quantityInput.val();
        }else{
          if(quantityNum != 1){
            quantityInput.attr('value', Number(quantityNum) - 1);
            quantityNum = quantityInput.val();
          }
        }
      }

      function changeProductOption(e){
        if(labelState[e] == 0){
          optionLabel[e].addClass('active_label');
          labelState[e] = 1;
        }else{
          optionLabel[e].removeClass('active_label');
          labelState[e] = 0;
        }
      }

      function init(){

        minusButton.on({
          'click': function() {
            event.preventDefault();
            controllQuantity(-1);
          }
        });

        plusButton.on({
          'click': function() {
            event.preventDefault();
            controllQuantity(1);
          }
        });

      };

      init();

    }

    if (document.getElementById('product')) {
      cartWrapControll();
    }

    //商品詳細ページ バリエーションの切り替え

    function changeProductOptions(target){
      var optionWrap = [];
      var currentDiv;
      var radioArray;
      var radioInput = $('input[type=radio]');
      var firstRadio = $('.radio1')
      var optionSelector = $('#ProductSelect-product-template');

      var optionValue = [];
      var optionLength;
      var optionTxt;

      var selectOptionName = [];
      var selectOptionValue = [];
      var selectOptionPrice = [];
      var selectOptionImage = [];
      var optionGetTrue = [];
      var changedOptionIndex = 0;

      var prodImages = $('#prodImages');
      var imgButtons = [];
      var imgButtonThumbs = [];

      var priceDisplay = $('#priceDisplay');

      function changeSelectors(){

        $.each(target.find('input[type=radio]:checked'), function(index) {
          optionValue[index] = $(this).val();
          optionLength = Number(index) + Number(1);
        });

        console.log('optionLength:' + optionLength);

        $.each(optionSelector.find('option'), function(index) {
          selectOptionName[index] = $(this).html().replace('&amp;', '&');
          selectOptionValue[index] = $(this).val().replace('&amp;', '&');
          selectOptionPrice[index] = $(this).attr('cprice');
          selectOptionImage[index] = $(this).attr('imgSRC');
          optionGetTrue[index] = true;
          console.log('selectOptionName[index]:' + selectOptionName[index]);
          for (let i = 0; i < optionLength; i++) {
            console.log('optionValue[i]:' + optionValue[i]);
            if(selectOptionName[index].indexOf(optionValue[i]) == -1){
              optionGetTrue[index] = false;
            }else{
            }
          }
          if(optionGetTrue[index]){
            optionSelector.val(selectOptionValue[index]);
            priceDisplay.html('¥' + selectOptionPrice[index]);
            changedOptionIndex = index;
          }

        });

        /*console.log('changedOptionIndex:' + changedOptionIndex);
        console.log('selectOptionImage[changedOptionIndex]:' + selectOptionImage[changedOptionIndex]);*/
        $.each(prodImages.find('.thumb_item'), function(i) {
          imgButtons[i] = $(this).find('button');
          imgButtonThumbs[i] = imgButtons[i].find('img').attr('src');
          if(imgButtonThumbs[i].indexOf(selectOptionImage[changedOptionIndex]) != -1){
            imgButtons[i].click();
          }
        });


      }

      function getCurrentOptions(){
        $.each(target.find('.option_wrap'), function(index) {
          currentDiv = $(this).find('.current');
          radioArray = $(this).find('input[type=radio]:checked').val();
          currentDiv.html(radioArray);
          changeSelectors();
        });
      }

      function init(){
        radioInput.on({
          'click': function() {
            getCurrentOptions();
          }
        });

        /*firstRadio.click();*/

      }

      init();

    }

    if (document.getElementById('productOptions')) {
      changeProductOptions($('#productOptions'));
    }

    // カートページ 商品数の増減
    function controllProductQuantity(target){
      var minusButton = [];
      var plusButton = [];
      var quantityInput = [];
      var reloadButton = [];
      var quantityNum;

      function controllQuantity(num, vector){
        quantityNum = quantityInput[num].val();
        if(vector == 1){
          quantityInput[num].attr('value', Number(quantityNum) + 1);
          reloadButton[num].click();
        }else{
          if(quantityNum != 1){
            quantityInput[num].attr('value', Number(quantityNum) - 1);
            reloadButton[num].click();
          }
        }
      }

      function init(){
        $.each(target.find('.cart_item'), function(index) {
          minusButton[index] = $(this).find('.minus');
          plusButton[index] = $(this).find('.plus');
          quantityInput[index] = $(this).find('input[type="number"]');
          reloadButton[index] = $(this).find('.reload_button');
          minusButton[index].on({
            'click': function() {
              event.preventDefault();
              controllQuantity(index, -1);
            }
          });
          plusButton[index].on({
            'click': function() {
              event.preventDefault();
              controllQuantity(index, 1);
            }
          });
        });

      }

      init();

    }

    if (document.getElementById('cartItem')) {
      controllProductQuantity($('#cartItem'));
    }

    // 商品一覧ページ ページャーの実装
    function collectionPagePager(target){

      var currentPage = Number(1);
      var targetDom = $('#itemListWrap');
      var pages = target.attr('pagenate');
      var limit = 24;

      var productItemProp = [];

      function readNextPage(){

        productItemProp = [];

        $.each($('article').find('.product_item'), function(index) {
          productItemProp[index] = $(this).attr('paginate');
          if(productItemProp[index] == currentPage){
            $(this).css({'display': 'block'});
          }
        });

        currentPage = currentPage + Number(1);
        console.log(location.href + '?page=' + currentPage);


        if(pages < currentPage){
          target.remove();
        }else{
          $.ajax({
            url: location.href + '/?page=' + currentPage,
            cache: false,
            dataType: 'html',
            success: function(html) {
              var prop = [];
              var prodHTML = [];
              $.each($(html).find('#itemListWrap').find('.product_item'), function(index) {
                prodHTML[index] = $(this);
                targetDom.append(prodHTML[index]);
              });
            }
          });
        }

      }

      function init(){
        readNextPage();

        target.on({
          'click': function() {
            readNextPage();
          }
        });
      }

      init();

    }

    if (document.getElementById('productPagenate')) {
      collectionPagePager($('#productPagenate'));
    }

    // ニュースページ ページャーの実装

    function newsPagePager(target){

      var currentPage = Number(1);
      var targetDom = $('#newsListWrap');
      var pages = target.attr('pagenate');
      var limit = 10;

      var newsItemProp = [];

      function readNextPage(){

        newsItemProp = [];

        $.each($('article').find('.news_item'), function(index) {
          newsItemProp[index] = $(this).attr('paginate');
          if(newsItemProp[index] == currentPage){
            $(this).css({'display': 'block'});
          }
        });

        currentPage = currentPage + Number(1);
        console.log(location.href + '?page=' + currentPage);


        if(pages < currentPage){
          target.remove();
        }else{
          $.ajax({
            url: location.href + '/?page=' + currentPage,
            cache: false,
            dataType: 'html',
            success: function(html) {
              var prop = [];
              var prodHTML = [];
              $.each($(html).find('#newsListWrap').find('.news_item'), function(index) {
                prodHTML[index] = $(this);
                targetDom.append(prodHTML[index]);
              });
            }
          });
        }

      }

      function init(){
        readNextPage();

        target.on({
          'click': function() {
            readNextPage();
          }
        });
      }

      init();

    }

    if (document.getElementById('newsPagenate')) {
      newsPagePager($('#newsPagenate'));
    }


    /* ログインページの切り替えレイアウト */
    function switchLoginFunction(){
      var loginLayout = $('#login');
      var resetLayout = $('#reset');
      var resetPassword = $('#resetPassword');
      var loginBack = $('#loginBack');

      function switchLogin(){
        $('#contentSwitcher').animate({opacity:0}, 400, function(){
            loginLayout.css({'display': 'block'});
            resetLayout.css({'display': 'none'});
            setTimeout(function() {
              $("#contentSwitcher").animate({opacity: 1}, 400);
            }, 50);
        });
      }

      function switchReset(){
        $('#contentSwitcher').animate({opacity:0}, 400, function(){
            loginLayout.css({'display': 'none'});
            resetLayout.css({'display': 'block'});
            setTimeout(function() {
              $("#contentSwitcher").animate({opacity: 1}, 400);
            }, 50);
        });
      }

      function init(){

        resetPassword.on({
          'click': function() {
            event.preventDefault();
            switchReset();
          }
        });

        loginBack.on({
          'click': function() {
            event.preventDefault();
            switchLogin();
          }
        });

      }

      init();

    }

    if (document.getElementById('contentSwitcher')) {
      switchLoginFunction();
    }

    /* 住所一覧ページの切り替えレイアウト */
    function switchAddressFunction(){
      var addressContentWrap = $('#addressContentWrap');
      var wrapperList = $('#wrapperList');
      var wrapperAdd = $('#wrapperAdd');
      var addressList = $('#addressList');
      var addressEdit = $('#addressEdit');
      var adminBar = $('#adminBar');
      var editbutton = [];
      var editId = [];


      function switchList(){
        adminBar.removeClass('mode-edit').addClass('mode-list');
        window.scroll({top: 0, behavior: 'smooth'});
        addressContentWrap.animate({opacity:0}, 400, function(){
          $('.content_wrapper').css({'display': 'none'});
          wrapperList.css({'display': 'block'});
          addressContentWrap.css({'display': 'block'});
          setTimeout(function() {
            addressContentWrap.animate({opacity: 1}, 400);
          }, 50);
        });
      }

      function switchAdd(){
        adminBar.addClass('mode-edit').removeClass('mode-list');
        window.scroll({top: 0, behavior: 'smooth'});
        addressContentWrap.animate({opacity:0}, 400, function(){
            $('.content_wrapper').css({'display': 'none'});
            wrapperAdd.css({'display': 'block'});
            addressContentWrap.css({'display': 'block'});
            setTimeout(function() {
              addressContentWrap.animate({opacity: 1}, 400);
            }, 50);
        });
      }

      function switchEdit(e){
        adminBar.addClass('mode-edit').removeClass('mode-list');
        window.scroll({top: 0, behavior: 'smooth'});
        addressContentWrap.animate({opacity:0}, 400, function(){
            $('.content_wrapper').css({'display': 'none'});
            $('#' + editId[e]).css({'display': 'block'});
            addressContentWrap.css({'display': 'block'});
            setTimeout(function() {
              addressContentWrap.animate({opacity: 1}, 400);
            }, 50);
        });
      }

      function init(){
        addressList.on({
          'click': function() {
            event.preventDefault();
            switchList();
          }
        });

        addressEdit.on({
          'click': function() {
            event.preventDefault();
            switchAdd();
          }
        });

        $.each($('article').find('.btn_edit'), function(index) {
          editbutton[index] = $(this);
          editId[index] = $(this).attr('formId');
          editbutton[index].on({
            'click': function() {
              console.log(editId[index]);
              switchEdit(index);
            }
          });
        });

      }

      init();

    }

    if (document.getElementById('addressContentWrap')) {
      switchAddressFunction();
    }


    /* Slick */
    var nextButtonHTML = '<button class="comp-slider-caret next-arrow"><svg viewBox="0 0 15.99 17.3"><polyline class="cls-1" points=".5 16.44 13.99 8.65 .5 .87"/></svg></button>';
    var prevButtonHTML = '<button class="comp-slider-caret prev-arrow"><svg viewBox="0 0 15.99 17.3"><polyline class="cls-1" points="15.49 16.43 2 8.65 15.49 .87"/></svg></button>';



    // トップページ 商品スライダー
    if (document.getElementById('index')) {
      $('.slick-slider').slick({
      accessibility: false,
      infinite: false,
      dots: false,
      slidesToShow: 5,
      centerMode: false,
      autoplay: false,
      autoplaySpeed: 7000,
      speed: 400,
      prevArrow: prevButtonHTML,
      nextArrow: nextButtonHTML,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            infinite: true,
            slidesToShow: 2,
            centerPadding: '0',
            centerMode: false,
            autoplay: true,
          }
        }
      ]
      });
    }



  }

  preSetScript();

});
